// Service pour l'upload d'images de procédures
import bastionAuth from '../services/bastionAuthService';

/**
 * Upload une image vers le serveur
 * @param {File} file - Fichier image à uploader
 * @returns {Promise} - Promesse avec l'URL de l'image
 */
export const uploadProcedureImage = async (file) => {
  try {
    // Vérifications côté client
    if (!file.type.startsWith('image/')) {
      throw new Error('Seuls les fichiers image sont acceptés');
    }
    
    if (file.size > 5 * 1024 * 1024) { // 5MB
      throw new Error('La taille de l\'image doit être inférieure à 5MB');
    }
    
    // Créer le FormData
    const formData = new FormData();
    formData.append('image', file);
    
    // Headers avec authentification
    const headers = bastionAuth.getAuthHeaders();
    // Ne pas définir Content-Type pour FormData (le navigateur le fait automatiquement)
    delete headers['Content-Type'];
    
    const response = await fetch('/api/procedures/upload-image', {
      method: 'POST',
      headers: headers,
      body: formData
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de l\'upload');
    }
    
    const result = await response.json();
    
    return result;
    
  } catch (error) {
    console.error('Erreur upload image:', error);
    throw error;
  }
};

/**
 * Supprime une image du serveur
 * @param {string} filename - Nom du fichier à supprimer
 * @returns {Promise} - Promesse de suppression
 */
export const deleteProcedureImage = async (filename) => {
  try {
    console.log('🗑️ Suppression image:', filename);
    
    const response = await fetch(`/api/procedures/delete-image/${filename}`, {
      method: 'DELETE',
      headers: bastionAuth.getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de la suppression');
    }
    
    const result = await response.json();
    console.log('✅ Image supprimée avec succès');
    
    return result;
    
  } catch (error) {
    console.error('❌ Erreur suppression image:', error);
    throw error;
  }
};

/**
 * Extrait le nom de fichier d'une URL d'image
 * @param {string} imageUrl - URL de l'image (/uploads/procedures/filename.jpg)
 * @returns {string} - Nom du fichier
 */
export const extractFilenameFromUrl = (imageUrl) => {
  if (!imageUrl) return null;
  const parts = imageUrl.split('/');
  return parts[parts.length - 1];
};
